import { Button, EmptyState, Inline, Page } from '@7shifts/sous-chef';
import errorStateIllustration from '../../assets/error-state.svg';
import { useRouteError } from 'react-router-dom';
import * as logging from 'utils/logging';
import { hardReload } from 'utils/appUpdate';
import { __ } from 'i18n';

const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) return error.message;
    if (typeof error === 'string') return error;
    if (error && typeof error === 'object' && 'message' in error) {
        return String((error as { message: unknown }).message);
    }
    return '';
};

// Erro de carregamento de chunk após deploy: o bundle em cache do usuário
// referencia arquivos com hash que não existem mais na versão nova. Não é bug —
// basta recarregar. As mensagens variam por navegador (Chrome/Firefox/Safari).
const isVersionMismatchError = (error: unknown): boolean => {
    const message = getErrorMessage(error);
    return /dynamically imported module|Importing a module script failed|Unable to preload (CSS|module)|ChunkLoadError|Loading chunk \d+ failed/i.test(
        message
    );
};

const ErrorBoundary = () => {
    const error = useRouteError();
    const isVersionMismatch = isVersionMismatchError(error);

    if (!isVersionMismatch) {
        logging.error(getErrorMessage(error) || 'Unknown error', error);
    }

    const title = isVersionMismatch
        ? __('errorBoundary.newVersionTitle')
        : __('errorBoundary.title');
    const description = isVersionMismatch
        ? __('errorBoundary.newVersionDescription')
        : __('errorBoundary.description');
    const reloadLabel = isVersionMismatch
        ? __('errorBoundary.newVersionReload')
        : __('errorBoundary.reload');

    return (
        <Page>
            <Inline mt={120}>
                <EmptyState
                    actions={{
                        primary: (
                            <Button
                                onClick={() => {
                                    // `window.location.reload()` re-navega para
                                    // a mesma URL e pode ser respondido pelo
                                    // cache com o bundle velho — que é o motivo
                                    // de "atualizar" não resolver para alguns
                                    // clientes. `hardReload` fura o cache.
                                    void hardReload();
                                }}
                            >
                                {reloadLabel}
                            </Button>
                        )
                    }}
                    mediaUrl={errorStateIllustration}
                    title={title}
                >
                    {description}
                </EmptyState>
            </Inline>
        </Page>
    );
};

export default ErrorBoundary;
